/**
 * Unified FAQ Handler
 * Handles all FAQ sections without conflicts
 */

(function() {
  'use strict';

  // Prevent multiple initializations
  if (window.FAQInitialized) return;
  window.FAQInitialized = true;

  // FAQ State Management
  const FAQState = {
    sections: new Map(),
    initialized: false
  };

  /**
   * Initialize FAQ functionality
   */
  function initFAQ() {
    if (FAQState.initialized) return;
    
    console.log('Initializing unified FAQ handler...');
    
    // Find all FAQ accordions
    const accordions = document.querySelectorAll('.vn-faq-accordion, .faq-accordion');
    
    accordions.forEach(function(accordion) {
      const sectionId = accordion.getAttribute('data-section-id') || accordion.id || 'default';
      initFAQSection(accordion, sectionId);
    });
    
    FAQState.initialized = true;
    console.log('FAQ initialization complete');
  }

  /**
   * Initialize a specific FAQ section
   */
  function initFAQSection(accordion, sectionId) {
    if (FAQState.sections.has(sectionId)) {
      console.log('Section already initialized:', sectionId);
      return;
    }

    console.log('Initializing FAQ section:', sectionId);
    
    // Handle default open items
    const defaultOpenAnswers = accordion.querySelectorAll('.answer--default-open');
    defaultOpenAnswers.forEach(function(answer) {
      answer.style.display = 'block';
      answer.classList.remove('answer--default-open');
      answer.classList.add('faq-open');
      
      const icon = answer.previousElementSibling?.querySelector('.vn-faq-icon, .faq-toggle-icon');
      if (icon) {
        const plusMinus = icon.querySelector('.faq-plus, .faq-minus');
        if (plusMinus) {
          icon.querySelector('.faq-plus').style.opacity = '0';
          icon.querySelector('.faq-minus').style.opacity = '1';
        } else {
          icon.textContent = '-';
        }
      }
    });

    // Add click handlers to questions
    const questions = accordion.querySelectorAll('.question, .faq-question');
    questions.forEach(function(question) {
      // Remove any existing handlers
      question.onclick = null;
      
      // Add new click handler
      question.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        handleFAQClick(question, accordion);
      });
    });

    FAQState.sections.set(sectionId, true);
  }

  /**
   * Handle FAQ question click
   */
  function handleFAQClick(question, accordion) {
    const answer = question.nextElementSibling;
    if (!answer) return;

    const icon = question.querySelector('.vn-faq-icon, .faq-toggle-icon');
    const isOpen = answer.classList.contains('faq-open') || answer.style.display === 'block';

    // Close all other answers in this accordion
    const allAnswers = accordion.querySelectorAll('.answer');
    const allIcons = accordion.querySelectorAll('.vn-faq-icon, .faq-toggle-icon');
    
    allAnswers.forEach(function(otherAnswer) {
      if (otherAnswer !== answer) {
        otherAnswer.style.display = 'none';
        otherAnswer.classList.remove('faq-open');
      }
    });
    
    allIcons.forEach(function(otherIcon) {
      if (otherIcon !== icon) {
        const plusMinus = otherIcon.querySelector('.faq-plus, .faq-minus');
        if (plusMinus) {
          otherIcon.querySelector('.faq-plus').style.opacity = '1';
          otherIcon.querySelector('.faq-minus').style.opacity = '0';
        } else {
          otherIcon.textContent = '+';
        }
      }
    });

    // Toggle current answer
    if (isOpen) {
      answer.style.display = 'none';
      answer.classList.remove('faq-open');
      
      if (icon) {
        const plusMinus = icon.querySelector('.faq-plus, .faq-minus');
        if (plusMinus) {
          icon.querySelector('.faq-plus').style.opacity = '1';
          icon.querySelector('.faq-minus').style.opacity = '0';
        } else {
          icon.textContent = '+';
        }
      }
    } else {
      answer.style.display = 'block';
      answer.classList.add('faq-open');
      
      if (icon) {
        const plusMinus = icon.querySelector('.faq-plus, .faq-minus');
        if (plusMinus) {
          icon.querySelector('.faq-plus').style.opacity = '0';
          icon.querySelector('.faq-minus').style.opacity = '1';
        } else {
          icon.textContent = '-';
        }
      }
    }
  }

  /**
   * Re-initialize FAQ for theme editor
   */
  function reinitializeFAQ() {
    FAQState.sections.clear();
    FAQState.initialized = false;
    setTimeout(initFAQ, 100);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQ);
  } else {
    initFAQ();
  }

  // Re-initialize for Shopify theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      console.log('Shopify section loaded, reinitializing FAQ...');
      reinitializeFAQ();
    });
    
    document.addEventListener('shopify:section:unload', function(event) {
      console.log('Shopify section unloaded');
    });
  }

  // Fallback initialization
  setTimeout(initFAQ, 500);

  // Expose for debugging
  window.FAQHandler = {
    init: initFAQ,
    reinit: reinitializeFAQ,
    state: FAQState
  };

})();
